module.exports = __webpack_public_path__ + "img/icon_aside_more_active.02d81adb.svg";